import React from 'react'
import type { ProjectDetailStats } from '../../../types/projectAnalysis'
import { ProjectDetailKpiTile } from './project-detail-kpi-tile'

export function ProjectDetailOverviewKpis({ stats: s }: { stats: ProjectDetailStats }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-2">
      <ProjectDetailKpiTile
        title="Total hours"
        value={s.totalHours.toLocaleString(undefined, { maximumFractionDigits: 1 })}
        sub={`${s.monthlyData.length} months`}
      />
      <ProjectDetailKpiTile
        title="Billable"
        value={s.billableHours.toLocaleString(undefined, { maximumFractionDigits: 1 })}
        sub={`${s.utilizationRate.toFixed(1)}% util`}
      />
      <ProjectDetailKpiTile
        title="Non-billable"
        value={s.nonBillableHours.toLocaleString(undefined, { maximumFractionDigits: 1 })}
        sub="Logged"
      />
      <ProjectDetailKpiTile
        title="Resources"
        value={String(s.uniqueResources)}
        sub="Unique users"
      />
      <ProjectDetailKpiTile
        title="Avg hrs / res"
        value={
          s.uniqueResources > 0
            ? (s.totalHours / s.uniqueResources).toLocaleString(undefined, {
                maximumFractionDigits: 1,
              })
            : '—'
        }
        sub="Per resource"
      />
      <ProjectDetailKpiTile
        title="Late %"
        value={s.lateEntriesRate != null ? `${s.lateEntriesRate.toFixed(1)}%` : '—'}
        sub="Late / entries"
      />
      <ProjectDetailKpiTile
        title="Leave days"
        value={s.totalLeaveDays.toLocaleString(undefined, { maximumFractionDigits: 1 })}
        sub="In period"
      />
    </div>
  )
}
